import Vue from 'vue'
import Router from 'vue-router'

//routes
import HorizontalRoutes from './horizontal'
import AppConfig from '../constants/AppConfig'

// session components
const SignUpOne = () => import('Views/session/SignUpOne')
const LoginOne = () => import('Views/session/LoginOne')
const LockScreen = () => import('Views/session/LockScreen')
const ForgotPassword = () => import('Views/session/ForgotPassword')
const ResetPassword = () => import('Views/session/ResetPassword')

const Auth0CallBack = () => import('Components/Auth0Callback/Auth0Callback')

Vue.use(Router)

var THE_ROUTES = {
    mode: 'history',
    routes: [
        HorizontalRoutes,
        {
            path: '/callback',
            component: Auth0CallBack
        },
        {
            path: '/session/sign-up',
            component: SignUpOne,
            name: 'signup',
            meta: {
                title: 'signUp',
                breadcrumb: null
            }
        },
        {
            path: '/session/login',
            name: 'login',
            component: LoginOne,
            meta: {
                title: 'login',
                breadcrumb: null
            }
        },
        {
            path: '/session/lock-screen',
            component: LockScreen,
            meta: {
                title: 'Lock Screen',
                breadcrumb: null
            }
        },
        {
            path: '/session/forgot-password',
            component: ForgotPassword,
            meta: {
                title: 'forgotPassword',
                breadcrumb: null
            }
        },
        {
            path: '/session/reset-password',
            component: ResetPassword,
            meta: {
                title: 'resetPassword',
                breadcrumb: null
            }
        }
    ]
}

THE_ROUTES.routes.map((v, i) => {
    if (v.path) THE_ROUTES.routes[i].path = AppConfig.controlPanelPath + THE_ROUTES.routes[i].path

    if (v.children) {
        v.children.map((vv, ii) => {
            THE_ROUTES.routes[i].children[ii].path = AppConfig.controlPanelPath + THE_ROUTES.routes[i].children[ii].path
        })
    }
})

export default new Router(THE_ROUTES)
